import {checkNull} from '@/helpers'

export default {
    name: 'default',
    data() {
        return {
            cdn_url: window.APP_CONFIG.CDN_URL,
            icdn_url: window.APP_CONFIG.ICDN_URL,
            links: window.APP_CONFIG.LINKS,
            sub_menu: [
                { name: 'Home', route: 'home' },
                { name: 'FAQ', route: 'faq' },
                { name: 'Blog', route: 'home' },
                { name: 'Contact', route: 'support' },
            ],
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        withAccordion: {
            type: Boolean,
            default: false
        },
        hideBackBtn: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    methods: {
        init_links() {
            if(checkNull(this.links)) {
                this.links.forEach(val => {
                    if(val.name == 'blog')
                        this.sub_menu[2] = { name: 'Blog', route: val.url , isExternal: true }
                })
            }
            if (!this.sub_menu[2].isExternal) {
                this.sub_menu[2].hide = true
            }
        }
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters['auth/isAuthenticated']
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        }
    },
    created() {
        this.init_links()
    }
}
